import { listing } from '@/src/lib/api/endpoints/listing';
import { normalizeListingHref } from './listingHref';

export type ListingAutocompleteResolution =
  | { type: 'href'; href: string }
  | { type: 'resourceId'; resourceId: string }
  | { type: 'unresolved' };

/**
 * Resolves a `type: 'listing'` autocomplete suggestion's `lotIdEncoded` to a
 * routable destination. The autocomplete API only returns a bare encoded id,
 * not a route — the canonical HDP URL has to come from the listing detail
 * fetch's `resolved.canonicalUrl`. Falls back to the detail's containing
 * `resolved.resourceId` (an SRP) when no canonical URL is available, and to
 * `{ type: 'unresolved' }` when the fetch itself fails.
 */
export async function resolveListingAutocompleteHref(
  lotIdEncoded: string,
  options?: { signal?: AbortSignal },
): Promise<ListingAutocompleteResolution> {
  try {
    const detail = await listing.fetchListingDetailV3(lotIdEncoded, { signal: options?.signal });
    const href = normalizeListingHref(detail.resolved?.canonicalUrl);
    if (href) return { type: 'href', href };
    if (detail.resolved?.resourceId) return { type: 'resourceId', resourceId: detail.resolved.resourceId };
    return { type: 'unresolved' };
  } catch {
    return { type: 'unresolved' };
  }
}
